import React from "react";

export default function Hidden(props) {
  return (
    <label className="hidden">
      <input
        type={props.type ?? "text"}
        {...props}
        readOnly
        autoComplete="off"
      />
    </label>
  );
}
